// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aE84","content":"styles_content__2SNiW"};